module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAS1BMVEX+/v7///+wtLi0t7uusbX6+/vz9PUAAAAAABsAABrO0NMAAA4sOUjBw8d6gIeBho1udHwAAB5dZW8yPUs6RFEjMUF1eoKanqQ+SFS5BBybAAAAXUlEQVR4AeXPtQGAQBAEQNx5t/4bxfU9hklPN/ma1OasZbmhKPdqWtWNrq2PybSre109pDEnRwB1oDvXoh7r6qtIKNPx6izanLVKQIM8i2ONdb04ixlVOpr5Y/7IDBJgCpmRZsqJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/t3n-logo.png
// module id = q568
// module chunks = 94